// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2NmNi","amount":"Amount_amount__1qGta","tip":"Amount_tip__3Lpmv","tipHeader":"Amount_tipHeader__3hNJI","tipsWrap":"Amount_tipsWrap__2q31g"};